import { create } from 'zustand';

interface ToastState {
  toastMessage: string;
  isError: boolean;
  toastKey: number;
  setToastMessage: (toastMessage: string) => void;
  setIsError: (isError: boolean) => void;
  resetToastMessage: () => void;
}

const createToastStore = () =>
  create<ToastState>()(set => ({
    toastMessage: '',
    isError: false,
    toastKey: 0,
    setToastMessage: (toastMessage: string) =>
      set({ toastMessage, toastKey: Date.now() }),
    setIsError: (isError: boolean) => set({ isError }),
    resetToastMessage: () => set({ toastMessage: '', isError: false }),
  }));

export const useToastStore = createToastStore();

export const useToastPopupStore = createToastStore();

export default useToastStore;
